import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import AppShell from "@/components/layout/AppShell";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import NewsletterUnsubscribePage from "@/pages/NewsletterUnsubscribePage";
import OnboardingPage from "@/pages/OnboardingPage";
import ProfilePage from "@/pages/ProfilePage";
import EditProfilePage from "@/pages/EditProfilePage";
import SecurityPage from "@/pages/SecurityPage";
import AccessPage from "@/pages/AccessPage";
import PublicProfilePage from "@/pages/PublicProfilePage";
import XProfilePage from "@/pages/XProfilePage";
import SellerProfilePage from "@/pages/SellerProfilePage";
import SearchPage from "@/pages/SearchPage";
import StoriesPage from "@/pages/StoriesPage";
import StoryViewerPage from "@/pages/StoryViewerPage";
// iter167 · PostDetailPage komplett entfernt — Feed rendert Beschreibung + Media direkt inline; Deep-Links zeigen auf /user/{handle}?post={id}.
// iter242 · Deep-Link auf einzelne Paid-Media-Posts wieder eingebaut (User-Wunsch).
import PostDetailPage from "@/pages/PostDetailPage";
// iter161 · ReelDetailPage entfernt — Reels-Kategorie abgeschafft, Legacy-Route redirected zu /
import StudioPage from "@/pages/StudioPage";
import StudioProcessingDelayPage from "@/pages/StudioProcessingDelayPage";
import MarketplacePage from "@/pages/MarketplacePage";
import MarketplaceDetailPage from "@/pages/MarketplaceDetailPage";
import StillTouchedXPage from "@/pages/StillTouchedXPage";
import StxExclusivePage from "@/pages/StxExclusivePage";
import STXDetailPage from "@/pages/STXDetailPage";
import MysteryBagDetailPage from "@/pages/MysteryBagDetailPage";
import ListingEditorPage from "@/pages/ListingEditorPage";
import WatchlistPage from "@/pages/WatchlistPage";
import SavedPostsPage from "@/pages/SavedPostsPage";
import SearchAlertsPage from "@/pages/SearchAlertsPage";
import PrivacySettingsPage from "@/pages/PrivacySettingsPage";
import FollowRequestsPage from "@/pages/FollowRequestsPage";
import MutedSellersPage from "@/pages/MutedSellersPage";
import SellerRescuePage from "@/pages/SellerRescuePage";
import AdminWarehousePage from "@/pages/AdminWarehousePage";
import OrdersPage from "@/pages/OrdersPage";
import PurchaseCenterPage from "@/pages/PurchaseCenterPage";
import StudioSTXDigitalPage from "@/pages/StudioSTXDigitalPage";
import RescuePage from "@/pages/RescuePage";
import CreatorHelperPage from "@/pages/CreatorHelperPage";
import WatchAnalyticsPage from "@/pages/WatchAnalyticsPage";
import FollowingPage from "@/pages/FollowingPage";
import StudioSocialPage from "@/pages/StudioSocialPage";
import StudioFansPage from "@/pages/StudioFansPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import SocialPurchaseDetailPage from "@/pages/SocialPurchaseDetailPage";
import AboPurchaseDetailPage from "@/pages/AboPurchaseDetailPage";import TipsSuccessPage from "@/pages/TipsSuccessPage";
import MessagingSuccessPage from "@/pages/MessagingSuccessPage";
import SellerOrderDetailPage from "@/pages/SellerOrderDetailPage";
import StudioMonetizationPage from "@/pages/StudioMonetizationPage";
import StudioSubscriberBenefits from "@/pages/StudioSubscriberBenefits";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import CheckoutPayPage from "@/pages/CheckoutPayPage";
import ChatPage from "@/pages/ChatPage";
import PreSaleWizardPage from "@/pages/PreSaleWizardPage";
import FacetEditorPage from "@/pages/FacetEditorPage";
import SellerRequestsPage from "@/pages/SellerRequestsPage";
import SellerShipmentsPage from "@/pages/SellerShipmentsPage";
import MyListingsPage from "@/pages/MyListingsPage";
import GuestTrackingPage from "@/pages/GuestTrackingPage";
import ImpersonateLandingPage from "@/pages/ImpersonateLandingPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminPlatformPostPage from "@/pages/AdminPlatformPostPage";
import CheckoutPage from "@/pages/CheckoutPage";
import CartPage from "@/pages/CartPage";
import CartCheckoutPage from "@/pages/CartCheckoutPage";
import ModulGPreviewEnrollmentPage from "@/pages/ModulGPreviewEnrollmentPage";
import ModulGSubjectsPage from "@/pages/ModulGSubjectsPage";
import NotificationsPage from "@/pages/NotificationsPage";
import BookmarksPage from "@/pages/BookmarksPage";
import SubscriptionsPage from "@/pages/SubscriptionsPage";
import ModulGListingPreviewConfigPage from "@/pages/ModulGListingPreviewConfigPage";
import ModulGPreviewRequestsPage from "@/pages/ModulGPreviewRequestsPage";
import PayPalReturnPage from "@/pages/PayPalReturnPage";
import BuyerSettingsPage from "@/pages/BuyerSettingsPage";
import PayoutSettingsPage from "@/pages/PayoutSettingsPage";
import MessagesPage from "@/pages/MessagesPage";
import DMThreadPage from "@/pages/DMThreadPage";
import SystemMessageDetailPage from "@/pages/SystemMessageDetailPage";
import InquiryThreadPage from "@/pages/InquiryThreadPage";
import PresaleDetailPage from "@/pages/PresaleDetailPage";
import EmailVerifyLandingPage from "@/pages/EmailVerifyLandingPage";
import { STXThemeProvider, STXThemeScope } from "@/contexts/STXThemeContext";
import MaintenanceGate from "@/components/MaintenanceGate";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <STXThemeProvider>
      <BrowserRouter>
        <MaintenanceGate>
        <AppShell>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            {/* iter160 · Passwort-vergessen-Route wurde bisher gerendert im LoginPage-Link, aber die Route fehlte in App.js */}
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/newsletter/abmelden" element={<NewsletterUnsubscribePage />} />
            {/* iter174n · Magic-Link Landing für E-Mail-Verifikation */}
            <Route path="/verify-email" element={<EmailVerifyLandingPage />} />
            <Route path="/onboarding/profile" element={<OnboardingPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/profile/edit" element={<EditProfilePage />} />
            <Route path="/profile/security" element={<SecurityPage />} />
            <Route path="/profile/access" element={<AccessPage />} />
            <Route path="/profile/payout-settings" element={<PayoutSettingsPage />} />
            <Route path="/profile/privacy" element={<PrivacySettingsPage />} />
            <Route path="/profile/follow-requests" element={<FollowRequestsPage />} />
            <Route path="/user/:handle" element={<PublicProfilePage />} />
            <Route path="/user/:handle/social" element={<PublicProfilePage />} />
            <Route path="/user/:handle/marketplace" element={<SellerProfilePage area="MARKETPLACE" />} />
            <Route path="/user/:handle/stx" element={<STXThemeScope><SellerProfilePage area="STILLTOUCHEDX" /></STXThemeScope>} />
            <Route path="/x/:handle" element={<STXThemeScope><XProfilePage /></STXThemeScope>} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/stories" element={<StoriesPage />} />
            <Route path="/stories/viewer/:profileId" element={<StoryViewerPage />} />
            <Route path="/stories/:authorId" element={<StoriesPage />} />
            {/* iter242 · PostDetailPage neu für Deep-Links auf Paid-Posts (User-Wunsch). */}
            <Route path="/posts/:post_id" element={<PostDetailPage />} />
            {/* iter167 · PostDetailPage komplett entfernt. Interne Aufrufer nutzen /user/{handle}?post={id}. */}
            <Route path="/reels/:reel_id" element={<Navigate to="/" replace />} />
            <Route path="/studio" element={<StudioPage />} />
            <Route path="/studio/stx-digital" element={<StudioSTXDigitalPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/marketplace/:listingId" element={<MarketplaceDetailPage />} />
            <Route path="/stilltouchedx" element={<STXThemeScope><StillTouchedXPage /></STXThemeScope>} />
            <Route path="/stilltouchedx/exklusiv" element={<STXThemeScope><StxExclusivePage /></STXThemeScope>} />
            <Route path="/stilltouchedx/mystery/:category" element={<MysteryBagDetailPage />} />
            <Route path="/stilltouchedx/:listingId" element={<STXThemeScope><STXDetailPage /></STXThemeScope>} />
            <Route path="/listing/new" element={<ListingEditorPage />} />
            <Route path="/listing/edit/:listingId" element={<ListingEditorPage />} />
            <Route path="/watchlist" element={<WatchlistPage />} />
            <Route path="/saved-posts" element={<SavedPostsPage />} />
            <Route path="/search-alerts" element={<SearchAlertsPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/bookmarks" element={<BookmarksPage />} />
            <Route path="/subscriptions" element={<SubscriptionsPage />} />
            <Route path="/muted-sellers" element={<MutedSellersPage />} />
            <Route path="/seller/rescue" element={<SellerRescuePage />} />
            <Route path="/admin/warehouse" element={<AdminWarehousePage />} />
            <Route path="/profile/orders" element={<OrdersPage />} />
            <Route path="/profile/purchases" element={<PurchaseCenterPage />} />
            <Route path="/profile/purchases/legacy" element={<OrdersPage mode="buyer" />} />
            <Route path="/profile/purchases/social/:purchaseId" element={<SocialPurchaseDetailPage />} />
            <Route path="/profile/purchases/abo/:subscriptionId" element={<AboPurchaseDetailPage />} />
            <Route path="/profile/purchases/:orderId" element={<OrderDetailPage />} />
            <Route path="/profile/sales" element={<OrdersPage mode="seller" />} />
            <Route path="/profile/sales/:orderId" element={<SellerOrderDetailPage />} />
            <Route path="/rescue" element={<RescuePage />} />
            <Route path="/studio/helper" element={<CreatorHelperPage />} />
            <Route path="/studio/social" element={<StudioSocialPage />} />
            <Route path="/studio/fans" element={<StudioFansPage />} />
            <Route path="/studio/monetization" element={<StudioMonetizationPage />} />
            <Route path="/studio/subscriber-benefits" element={<StudioSubscriberBenefits />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/checkout/pay" element={<CheckoutPayPage />} />
            <Route path="/orders/:orderId/chat" element={<ChatPage />} />
            <Route path="/stilltouchedx/presale-wizard" element={<STXThemeScope><PreSaleWizardPage /></STXThemeScope>} />
            <Route path="/profile/facets" element={<FacetEditorPage />} />
            <Route path="/studio/requests" element={<SellerRequestsPage />} />
            <Route path="/studio/shipments" element={<SellerShipmentsPage />} />
            <Route path="/studio/listings" element={<MyListingsPage />} />
            <Route path="/studio/processing-delay" element={<StudioProcessingDelayPage />} />
            <Route path="/my-listings" element={<MyListingsPage />} />
            <Route path="/tracking" element={<GuestTrackingPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/users" element={<AdminDashboardPage />} />
            <Route path="/admin/settings" element={<AdminDashboardPage />} />
            <Route path="/admin/platform-post" element={<AdminPlatformPostPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/cart/checkout" element={<CartCheckoutPage />} />
            <Route path="/studio/preview" element={<ModulGPreviewEnrollmentPage />} />
            <Route path="/studio/preview/subjects" element={<ModulGSubjectsPage />} />
            <Route path="/studio/preview/subjects/:subjectId" element={<ModulGSubjectsPage />} />
            <Route path="/studio/preview/requests" element={<ModulGPreviewRequestsPage />} />
            <Route path="/studio/listings/:listingId/preview-config" element={<ModulGListingPreviewConfigPage />} />
            <Route path="/checkout/paypal-return" element={<PayPalReturnPage />} />
            <Route path="/checkout/paypal-cancel" element={<PayPalReturnPage />} />
            <Route path="/profile/buyer-settings" element={<BuyerSettingsPage />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/messages/social/:threadId" element={<DMThreadPage />} />
            <Route path="/messages/system/:messageId" element={<SystemMessageDetailPage />} />
            <Route path="/messages/inquiry/:conversationId" element={<InquiryThreadPage />} />
            <Route path="/messages/presale/:presaleId" element={<PresaleDetailPage />} />
            <Route path="/impersonate" element={<ImpersonateLandingPage />} />
            <Route path="/tips/success" element={<TipsSuccessPage />} />
            <Route path="/messaging/success" element={<MessagingSuccessPage />} />
            <Route path="/studio/creator-helper" element={<Navigate to="/studio/helper?tab=tariffs" replace />} />
            <Route path="/studio/watch-analytics" element={<WatchAnalyticsPage />} />
            <Route path="/following" element={<FollowingPage />} />
          </Routes>
        </AppShell>
        </MaintenanceGate>
        <Toaster position="top-center" />
      </BrowserRouter>
      </STXThemeProvider>
    </AuthProvider>
  );
}

export default App;
